import React from 'react';
import MapPerson from "./MapPerson";
//import {waitFrames} from "../helpers/waitFrames";
//import Icon from '../interface/Icon'
import {chapter} from "../ChapterGetter";
import {generateBattle} from "../Battle7/generateBattle";

export default class BattleSpace extends React.PureComponent {

  constructor(props) {
    super(props);

    //Go get the people in this space
    this.occupantSkins = [];
    if (props.battleId) {
      const battleEnemies = generateBattle(chapter.data.battles[props.battleId], chapter.data.combatants);
      this.occupantSkins = battleEnemies.map(e => e.skinId)
    }
    
    this.state = {
      //skinIndex: 0,
    }
  }

  componentDidMount() {
    //this.nextOccupant();
    // this.interval = setInterval(() => {
    //   //console.log('change skin')
    //
    //   this.setState(state => {
    //     return {
    //       skinIndex: (state.skinIndex < this.occupantSkins.length-1) ? state.skinIndex+1 : 0
    //     }
    //   })
    //
    // }, 2000)
  }

  // nextOccupant() {
  //
  //   if (this.state.occupantOpacity === 0) {
  //
  //       this.setState(state => {
  //         return {
  //           skinIndex: (state.skinIndex < this.occupantSkins.length-1) ? state.skinIndex+1 : 0
  //         }
  //       });
  //
  //     this.timeout = setTimeout(() => {
  //       this.setState({
  //         occupantOpacity: 1
  //       });
  //     }, 300)
  //     return;
  //   }
  //   if (this.state.occupantOpacity === 1) {
  //     //console.log('send out')
  //     this.timeout = setTimeout(() => {
  //       this.setState({
  //         occupantOpacity: 0
  //       });
  //     }, 1000)
  //   }
  //
  // }

  // componentWillUnmount() {
  //   clearTimeout(this.timeout)
  // }


  renderHackers() {

    const {pixelSize} = this.props;
    const map = {
      "1-1": {left:0, top:0,},

      "1-2": {left:pixelSize * 6, top:pixelSize * 8,},
      "2-2": {left:pixelSize * -6, top:pixelSize * -6,},

      "1-3": {left:0, top:pixelSize*13,},
      "2-3": {left:pixelSize * -14,  top:0,},
      "3-3": {left:pixelSize * 14,  top:pixelSize*4,},
    };

    const totalPositions = this.occupantSkins.length;
    return this.occupantSkins.map((skinId,index) => {
      const position = index+1;
      const {left,top} = map[`${position}-${totalPositions}`];
      return (
        <div
          key={position}
          style={{
          position: "relative",
          left,
          top,
          zIndex: totalPositions - index
        }}>
          <MapPerson
            skinId={skinId}
            pixelSize={pixelSize}
            cellSize={pixelSize*32}
            useHostileShadow={true}
          />
        </div>
      )
    });
  }


  render() {
    const {pixelSize, isActivated, x, y, isHeroNearby} = this.props;



    const cellSize = pixelSize * 32;
    const style = {
      container: {
        overflow: "hidden",
        width: cellSize,
        height: cellSize,
        position: "absolute",
        left:0,
        top:0,
        transform: `translate3d(${cellSize*x}px, ${cellSize*y}px, 0)`
      },
      svg: {
        width: cellSize * 4,
        display: "block",
        animation: !isActivated ? `svg_battleSpace 0.5s infinite steps(4)` : 'none'
      },
      path: {
        transition: 'stroke 0.3s'
      }
    };

    const fills = {
      "a": !isActivated ? "#ffd7d4" : "rgba(255,255,255,0)",
      "b": !isActivated ? "#c20003" : "#fff",
      "c": !isActivated ? "#d60000" : "#fff",
      "d": !isActivated ? "#ff8c80" : "#fff",
      "e": !isActivated ? "#ff5050" : "#fff",
      "f": !isActivated ? "#fe5f5f" : "#fff",
    };

    return (
      <React.Fragment>
      <div style={style.container}>

        <svg style={style.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 128 32" shapeRendering="crispEdges">
          <path style={style.path} stroke={fills["a"]} d="M64 0h10M86 0h10M33 1h10M53 1h10M64 1h1M73 1h1M86 1h1M95 1h1M97 1h10M117 1h10M2 2h10M20 2h10M33 2h1M42 2h1M53 2h1M62 2h1M64 2h1M73 2h1M86 2h1M95 2h1M97 2h1M106 2h1M117 2h1M126 2h1M2 3h1M11 3h1M20 3h1M29 3h1M33 3h1M42 3h1M53 3h1M62 3h1M64 3h1M72 3h1M87 3h1M95 3h1M97 3h1M106 3h1M117 3h1M126 3h1M2 4h1M11 4h1M20 4h1M29 4h1M33 4h1M41 4h1M54 4h1M62 4h1M64 4h1M68 4h4M88 4h4M95 4h1M97 4h1M105 4h1M118 4h1M126 4h1M2 5h1M10 5h1M21 5h1M29 5h1M33 5h1M37 5h4M55 5h4M62 5h1M64 5h1M68 5h1M91 5h1M95 5h1M97 5h1M101 5h4M119 5h4M126 5h1M2 6h1M6 6h4M22 6h4M29 6h1M33 6h1M37 6h1M58 6h1M62 6h1M64 6h1M68 6h1M91 6h1M95 6h1M97 6h1M101 6h1M122 6h1M126 6h1M2 7h1M6 7h1M25 7h1M29 7h1M33 7h1M37 7h1M58 7h1M62 7h1M64 7h1M68 7h1M91 7h1M95 7h1M97 7h1M101 7h1M122 7h1M126 7h1M2 8h1M6 8h1M25 8h1M29 8h1M33 8h1M37 8h1M58 8h1M62 8h1M64 8h1M67 8h1M92 8h1M95 8h1M97 8h1M101 8h1M122 8h1M126 8h1M2 9h1M6 9h1M25 9h1M29 9h1M33 9h1M36 9h1M59 9h1M62 9h1M64 9h3M93 9h3M97 9h1M100 9h1M123 9h1M126 9h1M2 10h1M5 10h1M26 10h1M29 10h1M33 10h3M60 10h3M97 10h3M124 10h3M2 11h3M27 11h3M2 20h3M27 20h3M2 21h1M5 21h1M26 21h1M29 21h1M33 21h3M60 21h3M97 21h3M124 21h3M2 22h1M6 22h1M25 22h1M29 22h1M33 22h1M36 22h1M59 22h1M62 22h1M64 22h3M93 22h3M97 22h1M100 22h1M123 22h1M126 22h1M2 23h1M6 23h1M25 23h1M29 23h1M33 23h1M37 23h1M58 23h1M62 23h1M64 23h1M67 23h1M92 23h1M95 23h1M97 23h1M101 23h1M122 23h1M126 23h1M2 24h1M6 24h1M25 24h1M29 24h1M33 24h1M37 24h1M58 24h1M62 24h1M64 24h1M68 24h1M91 24h1M95 24h1M97 24h1M101 24h1M122 24h1M126 24h1M2 25h1M6 25h4M22 25h4M29 25h1M33 25h1M37 25h1M58 25h1M62 25h1M64 25h1M68 25h1M91 25h1M95 25h1M97 25h1M101 25h1M122 25h1M126 25h1M2 26h1M10 26h1M21 26h1M29 26h1M33 26h1M37 26h4M55 26h4M62 26h1M64 26h1M68 26h1M91 26h1M95 26h1M97 26h1M101 26h4M119 26h4M126 26h1M2 27h1M11 27h1M20 27h1M29 27h1M33 27h1M41 27h1M54 27h1M62 27h1M64 27h1M68 27h4M88 27h4M95 27h1M97 27h1M105 27h1M118 27h1M126 27h1M2 28h1M11 28h1M20 28h1M29 28h1M33 28h1M42 28h1M53 28h1M62 28h1M64 28h1M72 28h1M87 28h1M95 28h1M97 28h1M106 28h1M117 28h1M126 28h1M2 29h10M20 29h10M33 29h1M42 29h1M53 29h1M62 29h1M64 29h1M73 29h1M86 29h1M95 29h1M97 29h1M106 29h1M117 29h1M126 29h1M33 30h10M53 30h10M64 30h1M73 30h1M86 30h1M95 30h1M97 30h10M117 30h10M64 31h10M86 31h10" />
          <path style={style.path} stroke={fills["b"]} d="M65 1h8M87 1h8M34 2h8M54 2h8M98 2h8M118 2h8M3 3h8M21 3h8M3 28h8M21 28h8M34 29h8M54 29h8M98 29h8M118 29h8M65 30h8M87 30h8" />
          <path style={style.path} stroke={fills["c"]} d="M65 2h1M72 2h1M87 2h1M94 2h1M34 3h1M41 3h1M54 3h1M61 3h1M65 3h1M68 3h4M88 3h4M94 3h1M98 3h1M105 3h1M118 3h1M125 3h1M3 4h1M10 4h1M21 4h1M28 4h1M34 4h1M37 4h4M55 4h4M61 4h1M65 4h1M67 4h1M92 4h1M94 4h1M98 4h1M101 4h4M119 4h4M125 4h1M3 5h1M6 5h4M22 5h4M28 5h1M34 5h1M36 5h1M59 5h1M61 5h1M65 5h1M67 5h1M92 5h1M94 5h1M98 5h1M100 5h1M123 5h1M125 5h1M3 6h1M5 6h1M26 6h1M28 6h1M34 6h1M36 6h1M59 6h1M61 6h1M65 6h1M67 6h1M92 6h1M94 6h1M98 6h1M100 6h1M123 6h1M125 6h1M3 7h1M5 7h1M26 7h1M28 7h1M34 7h1M36 7h1M59 7h1M61 7h1M65 7h1M67 7h1M92 7h1M94 7h1M98 7h1M100 7h1M123 7h1M125 7h1M3 8h1M5 8h1M26 8h1M28 8h1M34 8h1M36 8h1M59 8h1M61 8h1M65 8h2M93 8h2M98 8h1M100 8h1M123 8h1M125 8h1M3 9h1M5 9h1M26 9h1M28 9h1M34 9h2M60 9h2M98 9h2M124 9h2M3 10h2M27 10h2M3 21h2M27 21h2M3 22h1M5 22h1M26 22h1M28 22h1M34 22h2M60 22h2M98 22h2M124 22h2M3 23h1M5 23h1M26 23h1M28 23h1M34 23h1M36 23h1M59 23h1M61 23h1M65 23h2M93 23h2M98 23h1M100 23h1M123 23h1M125 23h1M3 24h1M5 24h1M26 24h1M28 24h1M34 24h1M36 24h1M59 24h1M61 24h1M65 24h1M67 24h1M92 24h1M94 24h1M98 24h1M100 24h1M123 24h1M125 24h1M3 25h1M5 25h1M26 25h1M28 25h1M34 25h1M36 25h1M59 25h1M61 25h1M65 25h1M67 25h1M92 25h1M94 25h1M98 25h1M100 25h1M123 25h1M125 25h1M3 26h1M6 26h4M22 26h4M28 26h1M34 26h1M36 26h1M59 26h1M61 26h1M65 26h1M67 26h1M92 26h1M94 26h1M98 26h1M100 26h1M123 26h1M125 26h1M3 27h1M10 27h1M21 27h1M28 27h1M34 27h1M37 27h4M55 27h4M61 27h1M65 27h1M67 27h1M92 27h1M94 27h1M98 27h1M101 27h4M119 27h4M125 27h1M34 28h1M41 28h1M54 28h1M61 28h1M65 28h1M68 28h4M88 28h4M94 28h1M98 28h1M105 28h1M118 28h1M125 28h1M65 29h1M72 29h1M87 29h1M94 29h1" />
          <path style={style.path} stroke={fills["d"]} d="M66 2h2M92 2h2M35 3h2M59 3h2M66 3h1M93 3h1M99 3h2M123 3h2M4 4h2M26 4h2M35 4h1M60 4h1M99 4h1M124 4h1M4 5h1M27 5h1M4 26h1M27 26h1M4 27h2M26 27h2M35 27h1M60 27h1M99 27h1M124 27h1M35 28h2M59 28h2M66 28h1M93 28h1M99 28h2M123 28h2M66 29h2M92 29h2" />
          <path style={style.path} stroke={fills["e"]} d="M68 2h4M37 3h4M67 3h1M101 3h4M6 4h4M36 4h1M66 4h1M100 4h1M5 5h1M35 5h1M66 5h1M99 5h1M4 6h1M35 6h1M66 6h1M99 6h1M4 7h1M35 7h1M66 7h1M99 7h1M4 8h1M35 8h1M99 8h1M4 9h1" />
          <path style={style.path} stroke={fills["f"]} d="M88 2h4M55 3h4M92 3h1M119 3h4M22 4h4M59 4h1M93 4h1M123 4h1M26 5h1M60 5h1M93 5h1M124 5h1M27 6h1M60 6h1M93 6h1M124 6h1M27 7h1M60 7h1M93 7h1M124 7h1M27 8h1M60 8h1M124 8h1M27 9h1M4 22h1M27 22h1M4 23h1M27 23h1M35 23h1M60 23h1M99 23h1M124 23h1M4 24h1M27 24h1M35 24h1M60 24h1M66 24h1M93 24h1M99 24h1M124 24h1M4 25h1M27 25h1M35 25h1M60 25h1M66 25h1M93 25h1M99 25h1M124 25h1M5 26h1M26 26h1M35 26h1M60 26h1M66 26h1M93 26h1M99 26h1M124 26h1M6 27h4M22 27h4M36 27h1M59 27h1M66 27h1M93 27h1M100 27h1M123 27h1M37 28h4M55 28h4M67 28h1M92 28h1M101 28h4M119 28h4M68 29h4M88 29h4" />

          <style>
            {`

            @keyframes svg_battleSpace {
                  0% { transform: translate3d(0,0,0) }
                  100% { transform: translate3d(-100%,0,0) }
            }
        `}
          </style>
        </svg>

        {/*<div style={{position: "absolute", left:0, top:0, bottom:0, right:0, padding: "1em", color: "#c20003"}}>*/}
        {/*todo {props.battleLevel}*/}
        {/*</div>*/}

        {/*props.noRecoveryAfterWin && (
        <div style={{position: "absolute", left:pixelSize * 10, top:pixelSize * 9}}>
          <Icon
            category="battleSpaceSkull"
            pixelSize={pixelSize}
          />
        </div>
      )*/}
      </div>
      <div style={{
        position: "absolute",
        left:cellSize*x,
        top:(cellSize*y) - pixelSize*16,
        transform: isHeroNearby ? `scale3d(0,0,1)` : `scale3d(1,1,1)`,
        transformOrigin: "50% 75%",
        transition: "transform 0.3s steps(3), opacity 0.3s",
        width: cellSize,
        height: cellSize,
        opacity: isHeroNearby ? 0 : 1,
      }}>
        {this.renderHackers()}
      </div>
      </React.Fragment>
    )
  }
}
